var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-types-view mt-3"},_vm._l((_vm.event_types),function(each,index){return _c('div',{key:index,staticClass:"event-type mb-2 me-2"},[_c('div',{staticClass:"box",style:(`background:${each.background};border:${each.border}`)}),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(each.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }